export var ReviewTabs;
(function (ReviewTabs) {
    ReviewTabs["Open"] = "issues:open";
    ReviewTabs["Handled"] = "issues:handled";
})(ReviewTabs || (ReviewTabs = {}));
